import { FeatureCard } from "./FeatureCard";
import { CORE_FEATURES } from "./data";

export function CoreFeatures() {
  return (
    <section id="features" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Everything You Need to Run Your MSP
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Replace scattered tools with a single, cohesive ecosystem designed to improve
            efficiency and client satisfaction.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {CORE_FEATURES.map((feature) => (
            <FeatureCard key={feature.title} feature={feature} />
          ))}
        </div>
      </div>
    </section>
  );
}
